import SystemZoomInLine from './system-zoom-in-line.component.js'

export * from './system-zoom-in-line.component.js'
export default SystemZoomInLine

SystemZoomInLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-zoom-in-line': SystemZoomInLine
  }
}
